export default "__VITE_ASSET__Cf$WoLpQ__";